/**
 * Generated by orval 🍺
 * Do not edit manually.
 * STBportalen
 * OpenAPI spec version: 1.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  NotifyContactDto
} from '../../model';

import { customInstance } from '../../../mutator/custom-instance';
import type { ErrorType , BodyType } from '../../../mutator/custom-instance';




export const postApiEmailNotifyProjectContact = (
    notifyContactDto?: BodyType<NotifyContactDto>,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/email/notifyProjectContact`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notifyContactDto, signal
    },
      );
    }




export const getPostApiEmailNotifyProjectContactMutationKey = () => ['postApiEmailNotifyProjectContact'] as const;

export const getPostApiEmailNotifyProjectContactMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmailNotifyProjectContact>>, TError,PostApiEmailNotifyProjectContactMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmailNotifyProjectContact>>, TError,PostApiEmailNotifyProjectContactMutationVariables, TContext> => {

const mutationKey = getPostApiEmailNotifyProjectContactMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmailNotifyProjectContact>>, PostApiEmailNotifyProjectContactMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiEmailNotifyProjectContact(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmailNotifyProjectContactMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmailNotifyProjectContact>>>
    export type PostApiEmailNotifyProjectContactMutationBody = BodyType<NotifyContactDto> | undefined
    export type PostApiEmailNotifyProjectContactMutationError = ErrorType<unknown>
    export type PostApiEmailNotifyProjectContactMutationVariables = {data?: BodyType<NotifyContactDto>}

    export const usePostApiEmailNotifyProjectContact = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmailNotifyProjectContact>>, TError,PostApiEmailNotifyProjectContactMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmailNotifyProjectContact>>,
        TError,
        PostApiEmailNotifyProjectContactMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiEmailNotifyProjectContactMutationOptions(options), queryClient);
    }
    export const postApiEmailNotifyTeamLeader = (
    notifyContactDto?: BodyType<NotifyContactDto>,
 signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/api/email/notifyTeamLeader`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notifyContactDto, signal
    },
      );
    }




export const getPostApiEmailNotifyTeamLeaderMutationKey = () => ['postApiEmailNotifyTeamLeader'] as const;

export const getPostApiEmailNotifyTeamLeaderMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmailNotifyTeamLeader>>, TError,PostApiEmailNotifyTeamLeaderMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiEmailNotifyTeamLeader>>, TError,PostApiEmailNotifyTeamLeaderMutationVariables, TContext> => {

const mutationKey = getPostApiEmailNotifyTeamLeaderMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiEmailNotifyTeamLeader>>, PostApiEmailNotifyTeamLeaderMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  postApiEmailNotifyTeamLeader(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiEmailNotifyTeamLeaderMutationResult = NonNullable<Awaited<ReturnType<typeof postApiEmailNotifyTeamLeader>>>
    export type PostApiEmailNotifyTeamLeaderMutationBody = BodyType<NotifyContactDto> | undefined
    export type PostApiEmailNotifyTeamLeaderMutationError = ErrorType<unknown>
    export type PostApiEmailNotifyTeamLeaderMutationVariables = {data?: BodyType<NotifyContactDto>}

    export const usePostApiEmailNotifyTeamLeader = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiEmailNotifyTeamLeader>>, TError,PostApiEmailNotifyTeamLeaderMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiEmailNotifyTeamLeader>>,
        TError,
        PostApiEmailNotifyTeamLeaderMutationVariables,
        TContext
      > => {
      return useMutation(getPostApiEmailNotifyTeamLeaderMutationOptions(options), queryClient);
    }
